//Clipboard  ie9+兼容
// import Clipboard from "clipboard";
import { Message } from "element-ui";
export default {
  //搜索过滤 只保留中文字，数字，英文单词
  searchFilter(string) {
    return /^([\u4e00-\u9fa50-9a-zA-Z];?)+$/g.test(string);
  },
  //复制
  copy(name) {
    var clipboard = new Clipboard("." + name);
    clipboard.on("success", (e) => {
      Message({
        message: "复制成功，请通过Ctrl+V进行复制吧",
        type: "success",
        duration: 2000,
        center: true,
      });
      // 释放内存
      clipboard.destroy();
    });
    clipboard.on("error", (e) => {
      // 不支持复制
      Message({
        message: "该浏览器不支持自动复制",
        type: "warning",
        duration: 2000,
        center: true,
      });
      // 释放内存
      clipboard.destroy();
    });
  },
  //换行符*转换
  changLine(string){
    var s= string.replace(/[\r\n]\*/g,"<br/>")
    return s
  },
  //导出生成txt
  exportTXT(filename, text){
   
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
     
      element.style.display = 'none';
      document.body.appendChild(element);
     
      element.click();
     
      document.body.removeChild(element);
    
  },
  //动态滚动条
  scroll(top){
    var n = 0;
    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
      scrollTop=scrollTop-top
    var timer1 = setInterval(() => {
      n++;
      window.scrollBy(0, -scrollTop / 20);
      if (n == 20) {
        clearInterval(timer1);
      }
    }, 20);
  },
  //递归判断列表，把最后的children设为undefined
  getTreeData(data){
    for(var i=0;i<data.length;i++){
      if(data[i].children.length<1){
        // children若为空数组，则将children设为undefined
        data[i].children=undefined;
      }else {
        // children若不为空数组，则继续 递归调用 本方法
        this.getTreeData(data[i].children);
      }
    }
    return data;
  },
};
